import { useState } from 'react';

/**
 * 아파트 매물(A1/B1) 정보 조회 + 모달 상태를 관리한다.
 *
 * @param {object} api - ApiContext에서 제공하는 api 객체
 * @returns {{
 *   aptA1B1ListInfo: object|null,
 *   isFetchingAptA1B1Info: boolean,
 *   aptA1B1InfoFetchError: boolean,
 *   showSaleModal: boolean,
 *   setShowSaleModal: function,
 *   modalIsRent: boolean,
 *   pyeongName: string,
 *   handleSaleClick: function
 * }}
 */
export function useAptSaleInfo(api) {
  const [aptNo, setAptNo] = useState(null);
  const [aptA1B1ListInfo, setAptA1B1ListInfo] = useState(null);
  const [isFetchingAptA1B1Info, setIsFetchingAptA1B1Info] = useState(false);
  const [aptA1B1InfoFetchError, setAptA1B1InfoFetchError] = useState(false);
  const [showSaleModal, setShowSaleModal] = useState(false);
  const [modalIsRent, setModalIsRent] = useState(false);
  const [pyeongName, setPyeongName] = useState('');

  const fetchAptSaleInfo = async (apt_no, pyeongNo, isRent) => {
    setIsFetchingAptA1B1Info(true);

    try {
      const { data, error } = await api.getAptSaleInfo(apt_no, pyeongNo, isRent);

      if (error) {
        console.error('아파트 매물 정보 조회 오류:', error);
        setAptA1B1InfoFetchError(true);
        setAptA1B1ListInfo(null);
        return;
      }

      setAptA1B1ListInfo(data);
      setAptA1B1InfoFetchError(false);
    } catch (error) {
      console.error('아파트 매물 정보 조회 중 오류 발생:', error);
      setAptA1B1InfoFetchError(true);
      setAptA1B1ListInfo(null);
    } finally {
      setIsFetchingAptA1B1Info(false);
    }
  };

  const handleSaleClick = (complexNo, pyeongNo, isRent, pyeongNameValue) => {
    setAptNo(complexNo);
    setModalIsRent(isRent);
    fetchAptSaleInfo(complexNo, pyeongNo, isRent);
    setShowSaleModal(true);
    setPyeongName(pyeongNameValue);
  };

  return {
    aptNo,
    aptA1B1ListInfo,
    isFetchingAptA1B1Info,
    aptA1B1InfoFetchError,
    showSaleModal,
    setShowSaleModal,
    modalIsRent,
    pyeongName,
    handleSaleClick,
  };
}
